module.exports = __webpack_public_path__ + "img/icon-ad.6bc5808d.png";